(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initTimelineTabs = (section) => {
 if (!(section instanceof HTMLElement)) return;
 if (section.dataset.timelineTabsInitialized === "true") return;

 const tabs = Array.from(section.querySelectorAll("[data-timeline-tab]"));
 const panels = Array.from(section.querySelectorAll("[data-timeline-panel]"));
 if (!tabs.length || !panels.length) return;

 const activeTabCount = tabs.filter((tab) => tab.getAttribute("aria-selected") === "true").length;
 const normalizeInitialSelection = activeTabCount > 1 ? 0 : tabs.findIndex((tab) => tab.getAttribute("aria-selected") === "true");

 const activate = (index) => {
 tabs.forEach((tab, i) => {
 const active = i === index;
 tab.setAttribute("aria-selected", String(active));
 tab.setAttribute("tabindex", active ? "0" : "-1");
 });

 panels.forEach((panel, i) => {
 const active = i === index;
 panel.toggleAttribute("inert", !active);
 panel.setAttribute("tabindex", active ? "0" : "-1");
 });
 };

 tabs.forEach((tab, index) => {
 tab.addEventListener("click", () => activate(index));
 tab.addEventListener("keydown", (event) => {
 const key = event.key;
 const isPrev = key === "ArrowLeft";
 const isNext = key === "ArrowRight";
 const isHome = key === "Home";
 const isEnd = key === "End";
 if (!isPrev && !isNext && !isHome && !isEnd) return;

 event.preventDefault();

 let next = index;
 if (isPrev) next = (index - 1 + tabs.length) % tabs.length;
 if (isNext) next = (index + 1) % tabs.length;
 if (isHome) next = 0;
 if (isEnd) next = tabs.length - 1;

 tabs[next]?.focus();
 activate(next);
 });
 });

 activate(normalizeInitialSelection >= 0 ? normalizeInitialSelection : 0);
 section.dataset.timelineTabsInitialized = "true";
 };

 document.querySelectorAll("[data-timeline-tabs]").forEach((section) => initTimelineTabs(section));
})();

  } catch(e) { console.error(e); }
})();
})();
